var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVatControlStatement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Vrstva_2",
    "data-name": "Vrstva 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 143 143",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "DI_4L_main",
    d: "M57.7 80.4h52.2M57.7 92.1h52.2M57.7 103.8h52.2M122.4 55.7V38.4L104 21.5H48.3c-2 0-3.6 1.6-3.6 3.6v92c0 2 1.6 3.6 3.6 3.6h70.5c2 0 3.6-1.6 3.6-3.6V55.8zM40.1 28.8h-4.5c-2 0-3.6 1.6-3.6 3.6v77.5c0 2 1.6 3.6 3.6 3.6h4.5M27.5 36h-2.1c-2 0-3.6 1.6-3.6 3.6v63c0 2 1.6 3.6 3.6 3.6h2.1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "DI_4L_main",
    d: "M104 21.5v16.8l18.4.1M64.5 46.6l7.3-10.5c1.9-2.7 6-3 8.8-1.1s3.9 5.9 2 8.6L69.2 62.8c-1.9 2.7-4.4 3.1-6.7 1.6l-.3-.2c-2.3-1.6-2.8-3.9-.7-6.8l9.1-12.9c.9-1.3 2.7-1.6 4-.7s1.3 2.7.5 4L70 55.2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVatControlStatement);
export default __webpack_public_path__ + "static/media/VatControlStatement.280f82b7dd39b479c82b42a25e31b376.svg";
export { ForwardRef as ReactComponent };